<template>
  <div class="cw-map">
    <div class="cw-map-wrap">
      <img :src="imageSrc" class="cw-map-image" alt="Map" v-if="!sunstudyView">
      <div v-if="sunstudyView" class="cw-map-image cw-map-sunstudy">
        <div v-for="slide in slides" class="cw-map-sunstudy-slide" :class="{'is-active':slide.active}">
          <img :src="slide.src" :srcset="slide.srcset">
        </div>
      </div>

      <svg class="cw-map-svg">
        <map-region v-for="region in visibleRegions" :key="region.id" :region="region" :zoom="zoom"
                    v-if="regionVisible(region)"
                    :map="map"
                    :active="regionActive(region)"
                    :lit="isLit"
                    @click="onRegionClick(region)"
                    @mousemove="onRegionMouseEnter"
                    @mouseleave="onRegionMouseLeave"></map-region>
      </svg>
    </div>
  </div>
</template>

<script>
  import MapRegion from '@/components/Partials/MapRegion'
  import {mapGetters} from 'vuex'

  function pad (pad, str, padLeft) {
    if (typeof str === 'undefined') {
      return pad
    }
    if (padLeft) {
      return (pad + str).slice(-pad.length)
    } else {
      return (str + pad).substring(0, pad.length)
    }
  }

  export default {
    name: 'Map',
    props: ['map', 'activeEntity', 'sunstudySlide', 'sunstudyView'],
    data () {
      return {
        height: null,
        width: null
        // zoom: null
      }
    },
    computed: {
      slides () {
        const slides = []
        for (let i = 0; i <= this.sunstudyView.image_count - 1; i++) {
          const num = pad('0000', i, true)
          slides.push({
            active: this.sunstudySlide === i,
            src: `${this.sunstudyView.base_url}/${num}-640.jpg`,
            srcset: `${this.sunstudyView.base_url}/${num}-640.jpg 640w, ${this.sunstudyView.base_url}/${num}-1200.jpg 1200w`
          })
        }
        return slides
      },
      imageSrc () {
        return this.map.src
      },
      zoom () {
        return this.width / this.map.width
      },
      activeRegion () {
        if (!this.activeEntity) {
          return null
        }

        return this.visibleRegions.find(r => r.entity_id === this.activeEntity.id)
      },
      visibleRegions () {
        if (this.map.type === 'Objects') {
          return this.map.regions.data.filter(region => {
            if (!region.object) {
              return false
            }
            return this.objectsFiltered.find(obj => obj.id === region.object.id)
          })
        }

        return this.map.regions.data
      },
      ...mapGetters({
        objectsFiltered: 'getObjects',
        isLit: 'isLit'
      })
    },
    created () {
      if (!this.map) {
        throw new Error('karta hittas inte')
      }

      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      this.resize()
    },
    methods: {
      handleResize () {
        this.resize()
      },
      regionVisible (region) {
        if (this.map.type === 'Objects') {
          return this.objectsFiltered.find((obj) => obj.id === region.object.id)
        }
        return true
      },
      regionLit (region) {
        if (this.map.type === 'Objects') {
          const obj = this.objectsFiltered.find((obj) => obj.id === region.object.id)
          return obj.lit
        }
        return false
      },
      regionActive (region) {
        if (!this.activeEntity) {
          return false
        }
        return this.activeEntity.id === region.entity_id
      },
      resize () {
        const ratio = this.map.height / this.map.width

        this.width = this.$el.clientWidth
        this.height = this.width * ratio

        // this.zoom = Math.min(1, this.width / this.map.width)
        // this.zoom = this.width / this.map.width
      },
      onRegionClick (region) {
        this.$emit('regionclick', region)
      },
      onRegionMouseEnter (region, e) {
        this.$emit('regionmousemove', region, e)
      },
      onRegionMouseLeave (region, e) {
        this.$emit('regionmouseleave', region, e)
      }
    },
    components: {
      'map-region': MapRegion
    }
  }
</script>
<style lang="scss" scoped>
  .cw-map {
    position: relative;
    user-select: none;
  }

  .cw-map .cw-map-wrap {
    position: relative;
    transition: all .4s;
    width: 100%;
    height: auto;
  }

  .cw-map .cw-map-wrap .cw-map-image {
    width: 100%;
    height: auto;
    // max-height: 100vh;
  }

  .cw-map .cw-map-wrap .cw-map-svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .cw-map .cw-map-wrap .cw-map-image {
    z-index: 1;
  }

  .cw-map .cw-map-wrap .cw-map-svg {
    z-index: 10;
  }

  .cw-map-sunstudy {
    .cw-map-sunstudy-slide {
      // position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: none;

      &.is-active {
        display: block;
      }
    }

    img {
      width: 100%;
      height: auto;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Map.vue